export type ModelActivityLogPageFilters = {
  eventType: string;
  initiatedByType: string;
  associatedModelType: string;
  startDate: string;
  endDate: string;
};

export const emptyModelActivityLogPageFilters: ModelActivityLogPageFilters = {
  eventType: '',
  initiatedByType: '',
  associatedModelType: '',
  startDate: '',
  endDate: '',
};

export function getActiveModelActivityLogPageFilters(
  filters: ModelActivityLogPageFilters,
): Partial<ModelActivityLogPageFilters> {
  return Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== ''),
  ) as Partial<ModelActivityLogPageFilters>;
}
